import { useSelector } from 'react-redux';

import RootState from 'types/state/RootState';

const useBrand = (): string => {
    return useSelector((state: RootState): string => state.brand || '');
};

export default useBrand;
